import { render, staticRenderFns } from "./MathCol.vue?vue&type=template&id=1f783ca0&scoped=true&"
import script from "./MathCol.vue?vue&type=script&lang=js&"
export * from "./MathCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f783ca0",
  null
  
)

export default component.exports